// 2026-10-20 coder(lq): 导航只消费服务端真实菜单投影；搜索保留父路径，不用接口清单补造菜单。
export function indexNavigation(root) {
    const nodes = new Map(), trails = new Map(), ancestors = new Map()
    const visit = (node, trail, parentKeys) => {
        nodes.set(node.key, node)
        ancestors.set(node.key, parentKeys)
        const path = [...trail, node.title]
        trails.set(node.key, path)
        const children = node.children || []
        children.forEach(child => visit(child, path, [...parentKeys, node.key]))
    }
    if (root) visit(root, [], [])
    return { nodes, trails, ancestors }
}
export function searchNavigation(root, search) {
    if (!root) return []
    const text = search.trim().toLowerCase()
    const filter = node => {
        const menu = node.menu || {}
        if (!text || `${node.title} ${menu.resource_id || ''} ${menu.service_id || ''}`.toLowerCase().includes(text)) return node
        const children = (node.children || []).map(filter).filter(Boolean)
        return children.length ? { ...node, children } : null
    }
    const result = filter(root)
    return result ? [result] : []
}
export const initialMenu = node => node && node.canAdd && node.menu ? {
    authority: node.menu.authority, service_id: node.menu.service_id, resource_id: node.menu.resource_id,
    menuName: node.menu.menuName, status: node.menu.status,
} : null
